import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height: 100%;
  padding: 1.25rem;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  width: 100%;
  justify-self: 'flex-end';

  .tot {
    border: 1px solid #ccc;
    padding: 10px;
    font-size: 21px;
  }
`;

export const CanceladoContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 200px;
  justify-self: 'flex-end';
  background-color: #ffff00;

  .cancel {
    width: 100%;
    color: #ff0000;
    font-size: 1.625rem;
    padding: 0.3125rem;
    line-height: 2.4375rem;
    border-radius: 0.3125rem;
    background-color: yellow;
    text-align: center;
  }
`;
